import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { commonQueryKeys } from "@/common/data/commonQueryKeys";
import api from "@/common/utils/api";
import { ErrorResponse } from "@reflag/shared/api";
import { Org, PatchOrgArgsType } from "@reflag/shared/organizationAPI";

export function usePatchOrgMutation(orgId: string) {
  const queryClient = useQueryClient();
  return useMutation<Org, AxiosError<ErrorResponse>, PatchOrgArgsType>({
    mutationFn: (data: PatchOrgArgsType) =>
      api
        .patch<"/orgs/:orgId">(`/orgs/${orgId}`, data)
        .then((res) => res.data.org),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: commonQueryKeys.bootstrap(orgId),
      });
    },
  });
}
